import { StyledErrorPopup } from './ErrorPopup.styled';
import { AppModal, IconButton } from '../';
import { theme } from '../../theme';
import MintModalHeader from '../MintActionFigures/Modal/MintModalHeader';

const ErrorPopup = ({ data: { title = 'Error', description = null, isError = true}, onClose = () => {} }) => {
  return (
    <AppModal>
      <StyledErrorPopup>
        <MintModalHeader title={title} />
        <div className='error-popup-content'>
	  {description && <div className='error-popup-description'>{description}</div>}
          <div className='error-popup-button-holder'>
	    <IconButton onClick={onClose} backgroundOverwrite={isError ? theme.baseRed : theme.buttonGreen} borderOverwriteHover='rgba(0, 0, 0, .32)'>Ok</IconButton>
          </div>
        </div>
      </StyledErrorPopup>
    </AppModal>
  );
};

export default ErrorPopup;
